<a *ngIf="newsArticle"  [routerLink]="['/story', newsArticle?.id, newsArticle?.articleTitleSlug]" routerLinkActive="active">
    <div class="post small-post">
        <div class="entry-header">
            <div class="entry-thumbnail">
                <img class="img-fluid" [ngStyle]="{'max-width': this.articleWidth+'px'}" src="{{newsArticle?.articleImage}}" alt="Image" />
            </div>
        </div>
        <div class="post-content">
            <div class="entry-meta">
                <ul class="list-inline">
                    <li class="publish-date"><a href="#"><em class="fa fa-clock-o"></em> {{newsArticle?.dateLoaded | dateAgo}} </a></li>
                </ul>
            </div>
            <h2 class="entry-title postHeadline">
                <a href="#">
                    {{newsArticle?.articleTitle | truncatetext:textLimit}}
                </a>
            </h2>
        </div>
    </div><!--/post-->
</a>
